<template>
  <div class="px-xs-4 px-0 mx-0" :class="{ 'px-4': windowWidth <= 576 }">
<!--     <div class="row mb-2" style="background-color:blue;">
      <div
        class="col-xl-1 col-lg-3 col-md-6 col-xs-12 p-1 p-md-2 p-lg-3 p-xl-4 mx-4 mx-sm-3 mx-md-2 mx-lg-1 mx-xl-0 text-center"
        style="background-color:red"
      >
        HOLA
      </div>
    </div> -->

    <div v-if="loading || isLoading" class="col-md-12 text-center mb-4">
      <h5>{{ $t("cargando") }}....</h5>
    </div>
    <div v-else class="border rounded shadow p-2">
      <form @submit.prevent="saveDog">
        <div class="row mb-1">
          <div class="col-md-12">
            <button
              type="submit"
              data-toggle="tooltip"
              data-placement="top"
              class="btn btn-sm btn-success mt-2 float-right pt-2 pb-2 btn-w"
            >
              {{ $t("guardar cambios") }}
            </button>
          </div>
        </div>
        <!-- CHIP DEL PERRO + BUSQUEDA -->
        <div class="row">
          <div class="col-12 col-md-6">
            <label class="font-weight-normal">
              {{ $t("microchip") }}
              <small
                style="font-size:0.9em;"
                :class="{
                  'text-danger': $v.objDog.chip.$invalid,
                  'text-success': !$v.objDog.chip.$invalid,
                }"
                >&nbsp;({{ lenChip }}/15)&nbsp;</small
              >
              <span class="required">*</span>
            </label>
            <div class="input-group mb-0 pb-0">
              <div class="input-group-append">
                <input
                  type="text"
                  class="form-control pr-1 text-center"
                  :maxlength="15"
                  :class="{
                    'is-invalid': $v.objDog.chip.$error,
                    'is-valid': !$v.objDog.chip.$invalid,
                  }"
                  v-model="objDog.chip"
                  aria-describedby="chipHelp"
                />
                <button
                  style="height:34px; min-width:70px;"
                  class="btn btn-outline-secondary btn-sm px-0 mx-0"
                  type="button"
                  @click="buscarPerroChip"
                >
                  {{ $t("buscar") }}
                </button>
              </div>
            </div>
            <p
              style="font-size:0.75em;"
              v-if="!!buscarChip.texto"
              :class="buscarChip.class"
            >
              {{ buscarChip.texto }}
            </p>
          </div>
          <!-- TATUAJE -->
          <div class="col-12 col-md-6">
             <label class="font-weight-normal">
              {{ $t("tatuaje") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control"              
              v-model="objDog.tattoo"
            />

          </div>
        </div>
        <!-- Nombre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("nombre") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid': $v.objDog.name.$error,
                'is-valid': !$v.objDog.name.$invalid,
              }"
              v-model="$v.objDog.name.$model"
            />
            <!--   {{ $v.objDog.name }} -->
          </div>
        </div>
        <div class="row mb-0 pb-0">
          <!-- RAZA DEL PERRO -->
          <div class="col-md-12 mb-0 pb-0 my-1">
            <label class="font-weight-normal">
              {{ $t("raza") }}
              <span class="required">*</span>
            </label>
            <input
              v-model="$v.objDog.dog_breed_id.$model"
              class="mi-buscador"
              type="hidden"
            />

            <input
              v-if="!mostrarBuscadorRaza"
              :value="nombreRazaPerro($v.objDog.dog_breed_id.$model)"
              class="mi-buscador form-control"
              :class="{
                'is-invalid': $v.objDog.dog_breed_id.$error,
                'is-valid': !$v.objDog.dog_breed_id.$invalid,
              }"
              type="text"
              @click="mostrarBuscadorRaza = !mostrarBuscadorRaza"
            />
          </div>
        </div>
        <!-- COMPONENTE DE BUSQUEDA DE RAZAS -->
        <dog-breeds-search
          v-if="mostrarBuscadorRaza"
          :selected="$v.objDog.dog_breed_id"
          :lista="dataBreeds"
          @emitDogId="seleccionarRaza"
          @emitCancelarBuscarRaza="mostrarBuscadorRaza = false"
        ></dog-breeds-search>

        <!-- Fecha de nacimiento  | Sexo del perro -->
        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("fecha nacimiento") }}
              <span class="required">*</span>
            </label>
            <input
              type="date"
              class="form-control pr-0 text-center"
              :class="{
                'is-invalid': $v.objDog.birth_date.$error,
                'is-valid': !$v.objDog.birth_date.$invalid,
              }"
              v-model="fecha"
            />
          </div>
          <!-- SEXO -->
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("sexo") }}
              <span class="required">*</span>
            </label>
            <select
              class="form-control"
              v-model="$v.objDog.sex_id.$model"
              :class="{
                'is-invalid': $v.objDog.sex_id.$error,
                'is-valid': !$v.objDog.sex_id.$invalid,
              }"
            >
              <option value="1">{{ $t("macho") }}</option>
              <option value="2">{{ $t("hembra") }}</option>
            </select>
          </div>
        </div>

        <!-- libro tabla dog_books -->
        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("libro") }}
              <span class="required">*</span>
            </label>
            <p class="form-row form-row-wide validate-required">
              <select
                class="form-control"
                v-if="!loading"
                :class="{
                  'is-invalid': $v.objDog.dog_book_id.$error,
                  'is-valid': !$v.objDog.dog_book_id.$invalid,
                }"
                v-model="$v.objDog.dog_book_id.$model"
              >
                <option disabled>{{ $t("seleccione una opcion") }}</option>
                <option v-for="bk in dogBooks" :key="bk.id" :value="bk.id">{{
                  bk.book
                }}</option>
              </select>
            </p>
          </div>
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("numero") }}
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid': $v.objDog.book_number.$error,
                'is-valid': !$v.objDog.book_number.$invalid,
              }"
              v-model="$v.objDog.book_number.$model"
            />
          </div>
        </div>

        <!-- tipo cola -->

        <div class="row mb-1">
          <div class="col-md-6">
            <label class="font-weight-normal">
              {{ $t("cola") }} {{ $t("CC/SC") }}
              <span class="required">*</span>
            </label>
            <select
              class="form-control"
              :class="{
                'is-invalid': $v.objDog.cc_anuro.$error,
                'is-valid': !$v.objDog.cc_anuro.$invalid,
              }"
              v-model.number="$v.objDog.cc_anuro.$model"
            >
              <option value="1">{{ $t("si") }}</option>
              <option value="0">{{ $t("no") }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label
              class="font-weight-normal"
              v-if="$v.objDog.cc_anuro.$model === 1"
            >
              {{ $t("numero") }}
              <span class="required">*</span>
            </label>
            <input
              v-if="$v.objDog.cc_anuro.$model === 1"
              type="text"
              class="form-control"
              v-model="$v.objDog.cod_cc.$model"
              :class="{
                'is-invalid': $v.objDog.cod_cc.$error,
                'is-valid': !$v.objDog.cod_cc.$invalid,
              }"
            />
          </div>
        </div>

        <!-- padre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("padre") }} :
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid': $v.objDog.padre.$error,
                'is-valid': !$v.objDog.padre.$invalid,
              }"
              v-model="$v.objDog.padre.$model"
            />
          </div>
        </div>

        <!-- madre del perro -->
        <div class="row mb-1">
          <div class="col-md-12">
            <label class="font-weight-normal">
              {{ $t("madre") }} :
              <span class="required">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              :class="{
                'is-invalid': $v.objDog.madre.$error,
                'is-valid': !$v.objDog.madre.$invalid,
              }"
              v-model="$v.objDog.madre.$model"
            />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12">
            <div class="form-group form-check float-left pl-1">
          <!--     {{ objDog.not_owner }} -->
              <input
                type="checkbox"
                class="form-check-input d-none"
                id="exampleCheck1"
                v-model="objDog.not_owner"
              />
              <label class="form-check-label" for="exampleCheck1"
                >{{ $t("no soy propietario") }}*</label
              ><br />
              <small
                style="font-size:0.75em"
                class="text-danger"
                v-html="$t('marcar opcion no dueno')"
                >*</small
              >
            </div>
          </div>
        </div>

        <!-- propietario/s -->
        <div class="row mt-2">
          <div class="col-12">
            <div class="card border" ref="cardPropietarios">
              <div class="card-header">
                {{ $t("propietarios") }}
              </div>
              <div class="card-body pt-2">
                <div class="row">
                  <div class="col-12" v-if="!copropComp.mostrar">
                    <button
                      style="min-width:80px;"
                      type="button"
                      class="btn btn-primary btn-sm float-right"
                      @click="copropComp.mostrar = !copropComp.mostrar"
                    >
                      {{ $t("añadir") }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <dog-coprop
                      v-if="copropComp.mostrar"
                      :datos="copropComp.datos"
                      @emitAltaCoprop="altaCoprop"
                      @emitCancelar="cancelar()"
                    ></dog-coprop>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <dog-coprops-list
                      v-if="copropietarios.length > 0"
                      @emitEditCoprop="editCoprop"
                      @emitDelCoprop="delCoprop"
                      :lista="copropietarios"
                    ></dog-coprops-list>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- criador/es -->
        <div class="row mt-2">
          <div class="col-12">
            <div class="card border" ref="cardCriadores">
              <div class="card-header">{{ $t("criadores") }}</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12" v-if="!criadoresComp.mostrar">
                    <button
                      style="min-width:80px;"
                      type="button"
                      class="btn btn-primary btn-sm float-right"
                      @click="criadoresComp.mostrar = !criadoresComp.mostrar"
                    >
                      {{ $t("añadir") }}
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <dog-criador
                      v-if="criadoresComp.mostrar"
                      :datos="criadoresComp.datos"
                      @emitAltaCriador="altaCriador"
                      :listaCriadores="misCriadores"
                      @emitCancelar="cancelar()"
                    ></dog-criador>
                  </div>
                </div>
                <!-- lista criador/es -->
                <div class="row">
                  <div class="col-12">
                    <dog-criador-list
                      v-if="criadores.length > 0"
                      @emitEditCriador="editCriador"
                      @emitDelCriador="delCriador"
                      :lista="criadores"
                    ></dog-criador-list>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-md-12">
            <button
              style="font-size:1.11em;"
              type="submit"
              data-toggle="tooltip"
              data-placement="top"
              class="btn btn-sm btn-outline-success mt-2 py-2 btn-w btn-block"
            >
              {{ $t("alta perro") }}
            </button>
          </div>
        </div>

<!-- <pre>

        {{$v.objDog}}
</pre> -->

        <div class="clear"></div>
      </form>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { isEqual } from "lodash";

import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import DogCoprop from "./parts/Dog-Copropietario";
import DogCriador from "./parts/Dog-Criador";
import DogCriadorList from "./parts/Dog-criador-list";
import DogCopropsList from "./parts/Dog-copropietario-list";

import dogBreedsSearch from "./Dog-breeds-search";
import {
  required,
  minLength,
  maxLength,
  between,
  requiredIf,
  integer,
} from "vuelidate/lib/validators";

export default {
  name: "Dog-form",
  components: {
    dogBreedsSearch,
    DogCoprop,
    DogCriador,
    DogCriadorList,
    DogCopropsList,
  },
  props: ["indexEdit", "editing", "lang"],
  data() {
    return {
      /* gestion de copropietarios */
      copropietarios: [],
      copropComp: {
        mostrar: false,
        datos: null,
      },
      /*  gestion de criadores */
      criadores: [],
      misCriadores: [],
      criadoresComp: {
        mostrar: false,
        datos: null,
      },
      /* texto buscador chip */
      buscarChip: {
        texto: null,
        class: null,
      },
      /* mostrar buscador razas */
      mostrarBuscadorRaza: false,
      /* fab button */
      bgColor: "#C00B3D",
      position: "bottom-right",
      size: "medium",
      tooltip: this.$t("acciones"),
      windowWidth: 0,
      objDog: {
        name: null,
        dog_breed_id: null,
        birth_date: null,
        sex_id: null,
        padre: null,
        madre: null,
        criador: null,
        chip: null,
        dog_book_id: null,
        book_number: null,
        cc_anuro: null,
        cod_cc: null,
        not_owner: false,
        tattoo: null
      },
      isLoading: true,
      buscarPerroRaza: null,
      /* errores de las validaciones */
      errors: [],
    };
  },
  /* validaciones */
  validations: {
    objDog: {
      name: { required },
      dog_breed_id: { required },
      birth_date: { required },
      sex_id: { required },
      padre: { required },
      madre: { required },      
      chip: {        
        required,
        minLength: minLength(15),
        maxLength: maxLength(15),
      },
      dog_book_id: { required },
      book_number: {
        required: requiredIf(
          (objDog) => objDog.dog_book_id > 1 || objDog.dog_book_id === null
        ),
      },
      cc_anuro: { required },
      cod_cc: {
        required: requiredIf((objDog) => {
          return objDog.cc_anuro === 1;
        }),
      },
    },
  },
  methods: {
    ...mapActions("dog", ["createUserDog", "stBuscarPerroChip"]),
    ...mapActions("criador", ["acListarMisCriadores"]),
    /* buscar un perro por el chip */
    buscarPerroChip() {
      const chip = this.objDog.chip;
      console.log(chip);
      if (this.$v.objDog.chip.$invalid) {
        this.buscarChip.texto = "formato-chip-no-valido";
        this.buscarChip.class = "text-danger";
        return;
      } else {
        this.buscarChip.texto = null;
      }
      this.stBuscarPerroChip({ chip }).then((res) => {
        if (!!res) {
          this.buscarChip.texto = "chip-resultado";
          this.buscarChip.class = "text-success";
          let tmp = this.objDog;
          tmp.name = res.name;
          tmp.dog_breed_id = res.dog_breed_id;
          tmp.birth_date = res.birth_date;
          tmp.sex_id = res.sex_id;
          tmp.padre = res.padre;
          tmp.madre = res.madre;
          tmp.criador = res.criador;
          tmp.chip = res.chip;
          tmp.dog_book_id = res.dog_book_id;
          tmp.book_number = res.book_number;
          tmp.cc_anuro = res.cc_anuro;
          tmp.cod_cc = res.cod_cc;
          tmp.not_owner = res.not_owner;
        } else {
          //reseteamos los datos
          this.objDog = {
            name: null,
            dog_breed_id: null,
            birth_date: null,
            sex_id: null,
            padre: null,
            madre: null,
            criador: null,
            dog_book_id: null,
            book_number: null,
            cc_anuro: null,
            cod_cc: null,
            not_owner: false,
            chip: this.objDog.chip,
            tattoo: null
          };

          this.buscarChip.texto = "chip-no-resultado";
          this.buscarChip.class = "text-danger";
        }
      });
    },
    /* cancelamos y resetemanos copropietarios, criadores */
    cancelar() {
      this.criadoresComp = {
        mostrar: false,
        datos: null,
      };
      this.copropComp = {
        mostrar: false,
        datos: null,
      };
    },
    /* copropietarios */
    altaCoprop(data) {
      const datos = data.datos;
      const editando = data.editando;

      if (!editando) {
        //si no editamos buscamos si existe el usuario ya en la lista
        if (this.copropietarios.filter((c) => c.dni === datos.dni).length > 0) {
          return;
        }
      } else {
        //si editamos filtramos y actualizamos
        this.copropietarios.splice(data.id, 1);
      }
      this.copropietarios.push(_.cloneDeep(datos));
      this.copropComp = {
        mostrar: false,
        datos: null,
      };
    },
    /* editamos un copropietario de la lista, viene del child list */
    editCoprop(datos) {
      this.copropComp.datos = datos;
      this.copropComp.datos["editid"] = this.copropietarios.findIndex(
        (c) => c.dni === datos.dni
      );
      this.copropComp.mostrar = true;
    },
    /* eliminamos un copropietario, viene del child list */
    delCoprop(id) {
      console.log("delete coprop", id);
      this.copropietarios.splice(id, 1);
    },

    /* criadores */
    altaCriador(data) {
      const datos = data.datos;
      const editando = data.editando;

      if (!editando) {
        //si no editamos buscamos si existe el usuario ya en la lista
        if (
          this.criadores.filter(
            (c) => c.name === datos.name && c.lastname === datos.lastname
          ).length > 0
        ) {
          return;
        }
      } else {
        //si editamos filtramos y actualizamos
        this.criadores.splice(data.id, 1);
      }
      this.criadores.push(_.cloneDeep(datos));
      this.criadoresComp = {
        mostrar: false,
        datos: null,
      };
    },
    /* editamos un criador de la lista, viene del child list */
    editCriador(datos) {
      this.criadoresComp.datos = datos;
      this.criadoresComp.datos["editid"] = this.criadores.findIndex(
        (c) => c.name === datos.name && c.lastname === datos.lastname
      );
      this.criadoresComp.mostrar = true;
    },
    /* eliminamos un criador, viene del child list */
    delCriador(id) {
      console.log("delete coprop", id);
      this.criadores.splice(id, 1);
    },
    /* funcion para devolver la raza del perro dado su id (texto del id selelccionado) */
    nombreRazaPerro(id) {
      if (!id) return "";
      const locale = this.$i18n.locale;
      const raza = this.dogBreeds
        .find((b) => b.id === parseInt(id))
        .translations.find((t) => t.locale === locale);

      let salida = raza.name;
      if (!!raza.variety) salida += " " + raza.variety;
      if (!!raza.subvariety) salida += " " + raza.subvariety;
      return salida;
    },
    /* DAMOS DE ALTA EL PERRETE */
    createDog() {
      let invalid = false;
      const d = this.objDog;
      this.$v.$touch(); 
     //comprobamos si tenemos copropietarios siempre y cuando esté marcada NO dueño
      if (d.not_owner && this.copropietarios.length === 0) {
        this.$refs.cardPropietarios.classList.add("border-danger");
        invalid = true;
      } else {
        this.$refs.cardPropietarios.classList.remove("border-danger");
      }
     
     //comrpobamos que haya al menos un criador
      if (this.criadores.length === 0) {
        this.$refs.cardCriadores.classList.add("border-danger");
        invalid = true;
      } else {
        this.$refs.cardCriadores.classList.remove("border-danger");
      }


      //si la validacion no es completa
      console.log(this.$v.$invalid, invalid, this.$v)
      if (this.$v.$invalid || invalid) {
        return;
      }

      //preparamos los datos
      const datos = {
        objDog : this.objDog,
        criadores: this.criadores,
        copropietarios: this.copropietarios
      };

      this.createUserDog(datos).then(res => {
        console.log(res)
      })



     /*  if (
        this.objDog.cc_anuro === 1 &&
        (this.objDog.cod_cc === null || this.objDog.cod_cc === "")
      ) {
        alert(this.$t("error debe agregar los datos de cola cortada"));
        return;
      }
      this.createUserDog(this.objDog); */
    },
    /* cancelar el form */
    cancelFormDog() {
      this.$emit("emitEditingOrCreating", false);
    },
    saveDog() {
      if (this.editing) {
        this.editDog();
      } else {
        this.createDog();
      }
    },
    /* seleccionar raza */
    seleccionarRaza(id) {
      this.objDog.dog_breed_id = id;
      this.mostrarBuscadorRaza = false;
      this.buscarPerroRaza = null;
    },
  },
  computed: {
    ...mapState("dog", ["loading", "dogBreeds", "dogBooks"]),
    ...mapGetters("dog", [
      "getLocalDogBreeds",
      "getLocalDogBooks",
      "getCurrentEditDog",
    ]),
    lenChip() {
      if (!this.objDog.chip) return 0;
      else return this.objDog.chip.length;
    },
    fecha: {
      set(val) {
        this.objDog.birth_date = val;
      },
      get() {
        if (this.objDog.birth_date != null) {
          return this.objDog.birth_date.slice(0, 10);
        }
      },
    },
    dataBreeds: function() {
      if (this.dogBreeds != undefined && this.dogBreeds !== null) {
        let data = [];

        let columns = [
          { title: this.$t("nombre"), data: "name" },
          { title: this.$t("variedad"), data: "variety" },
          { title: this.$t("subvariedad"), data: "subvariety" },
        ];

        this.dogBreeds.forEach((e) => {
          let nombre = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "name"
          );
          let variedad = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "variety"
          );
          let subVariedad = this.$options.filters.filterTranslateBreed(
            "",
            null,
            e.translations,
            this.lang,
            "subvariety"
          );

          let row = {
            id: e.id.toString(),
            name: nombre,
            variety: variedad,
            subvariety: subVariedad,
          };
          data.push(row);
        });

        return { data, columns };
      }
    },
    buscarFiltrado() {
      if (this.buscarPerroRaza === null) {
        return;
      }

      let filtro = this.buscarPerroRaza.toUpperCase();

      const miFiltro = this.dataBreeds.data.filter((x) => {
        //hay filtro multiple
        let filtros = [];
        if (filtro.trim().includes("*")) {
          filtros = filtro.trim().split("*");
        }
        if (filtros.length > 1) {
          if (filtros[filtros.length - 1].trim() === "*") filtros.pop();
          const raza = filtros.some((f) => x.name.toUpperCase().includes(f));
          const variedad = filtros.some((f) =>
            x.variety.toUpperCase().includes(f)
          );
          const subVariedad = filtros.some((f) =>
            x.subvariety.toUpperCase().includes(f)
          );
          if (raza && variedad && subVariedad) {
            return x;
          }
          if (raza && variedad && !subVariedad) {
            return x;
          }
          if (raza && !variedad && subVariedad) {
            return x;
          }
        } else {
          if (
            x.name.toUpperCase().includes(filtro) ||
            x.variety.toUpperCase().includes(filtro) ||
            x.subvariety.toUpperCase().includes(filtro)
          )
            return x;
        }
      });

      return miFiltro.length > 20 ? miFiltro.splice(0, 20) : miFiltro;
    },
  },
  
  mounted() {
    console.log("creando un nuevo perrete");
    this.isLoading = false;
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.acListarMisCriadores().then((res) => (this.misCriadores = res));
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
>>> tr,
>>> td,
>>> th {
  padding: 1px;
  font-size: 0.9em;
}
>>> .input-group > .input-group-append {
  flex: 0 0 100%;
}
>>> .input-group .input-group-text {
  width: 100%;
}
table.mi-tabla {
  font-size: 0.7em;
  text-align: left;
}
table.mi-tabla td {
  text-align: left;
  height: 35px;
  padding: 0px;
  padding-left: 5px;
  min-height: 35px;
}
table.mi-tabla tbody tr:hover {
  background-color: red;
  color: white;
  font-weight: bold;
  cursor: pointer;
}
table.sp-table tbody tr td {
  text-align: left !important;
  color: red;
}
table.sp-table tr {
  min-width: 700px !important;
  border-bottom: 1px solid #ccc !important;
}
button.mini {
  font-size: 20px;
  color: white !important;
  min-width: 25px !important;
  max-width: 40px !important;
  min-height: 25px !important;
  max-height: 25px !important;
  padding: 0px 1px 4px 0px;
}
.btn-work {
  width: 25px !important;
  min-width: 25px !important;
  height: 25px;
  margin: 0 auto;
  padding: 0;
  padding-left: 2px;
  font-size: 1.8em;
  line-height: 25px;
  text-align: center !important;
}
.btn-work:hover {
  background-color: red !important;
  color: black;
}
input {
  min-height: 20px;
  height: 34px !important;
}
input.mi-buscador {
  background-color: white !important;
  padding: 1px 0px 1px 10px !important;
  font-size: 16px;
}
select {
  height: 34px !important;
  padding-top: 1px;
  padding-bottom: 1px;
}
</style>
